<template>
  <div>
    <b-alert
      v-if="serverError"
      dismissible
      show
      variant="danger"
    >
      <p v-if="internalServerMessage">
        {{ internalServerMessage }}
      </p>
      <p v-else>
        Es gab einen unerwarteten Fehler auf dem Server. Bitte überprüfen Sie
        die Logs und melden sich bei einem Administrator.
      </p>
    </b-alert>
    <b-alert
      v-if="accesDenied"
      dismissible
      show
      variant="danger"
    >
      <p>
        Sie haben nicht genügend Berechtigungen um diese Resource zu verändern
        oder anzuschauen.
      </p>
    </b-alert>

    <b-alert
      v-if="notFound"
      dismissible
      show
      variant="danger"
    >
      <p v-if="internalServerMessage">
        {{ internalServerMessage }}
      </p>
      <p v-else>
        Es gab einen unerwarteten Fehler auf dem Server. Bitte überprüfen Sie
        die Logs und melden sich bei einem Administrator.
      </p>
    </b-alert>

    <b-alert
      v-if="unknownError"
      dismissible
      show
      variant="danger"
    >
      <h6>Unbekannter Fehler</h6>
      <p>{{ unknownErrorMessage }}</p>
    </b-alert>

    <b-alert
      v-if="isUnauthorized"
      dismissible
      show
      variant="danger"
    >
      <p>
        Sie sind nicht eingeloggt. Bitte loggen Sie sich
        <router-link :to="'/login?source=' + currentUrl">
          hier
        </router-link>
        ein.
      </p>
    </b-alert>

    <b-alert
      v-if="networkError"
      dismissible
      show
      variant="danger"
    >
      <p>
        Netzwerk-Fehler. Stellen Sie sicher das Sie mit dem Internet verbunden
        sind.
      </p>
      <div v-if="currentFullUrl.indexOf('http://localhost:8080') != -1">
        DEV: Sicherstellen das das Backend lokal gestartet ist.
      </div>
    </b-alert>

    <b-alert
      v-if="propertyErrors.length > 0"
      dismissible
      show
      variant="danger"
    >
      <div
        v-for="(propertyError, propIndex) in propertyErrors"
        :key="propIndex"
      >
        <h6 v-if="!propertyMapping[propertyError.propertyName]">
          {{ propertyError.propertyName }}
        </h6>
        <h6 v-else>
          {{ propertyMapping[propertyError.propertyName] }}
        </h6>
        <ul>
          <li
            v-for="(propErrorMessage, errIndex) in propertyError.propErrors"
            :key="errIndex"
          >
            {{ propErrorMessage }}
          </li>
        </ul>
      </div>
    </b-alert>
    <b-alert
      v-if="otherErrors.length > 0"
      class="pre-formatted"
      dismissible
      show
      variant="danger"
    >
      <p
        v-for="(otherError, errorIndex) in otherErrors"
        :key="errorIndex"
      >
        {{ otherError }}
      </p>
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    errorObject: Error,
    propertyMapping: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      isUnauthorized: false,
      networkError: false,
      serverError: false,
      notFound: false,
      internalServerMessage: null,
      unknownError: false,
      unknownErrorMessage: "",
      accesDenied: false,
      errorMessage: "",
      propertyErrors: [],
      otherErrors: [],
      currentUrl: "",
      currentFullUrl: "",
    };
  },
  watch: {
    errorObject: function () {
      this.HandleErrorObject();
    },
  },
  created() {
    this.HandleErrorObject();
  },
  methods: {
    HandleErrorObject() {
      this.currentUrl = this.$route.fullPath;
      this.currentFullUrl = window.location.origin;

      if (this.errorObject.response) {
        switch (this.errorObject.response.status) {
          case 400:
            this.HandleStatus400();
            break;
          case 401:
            this.isUnauthorized = true;
            break;
          case 403:
            this.accesDenied = true;
            break;
          case 404:
            // if the responseData contains '<' it is most likely html, so we dont show it.
            if (this.errorObject.response.data.indexOf("<") == -1) {
              this.internalServerMessage = this.errorObject.response.data;
            }
            this.notFound = true;
            break;
          case 409:
            // if the responseData contains '<' it is most likely html, so we dont show it.
            if (this.errorObject.response.data.indexOf("<") == -1) {
              this.internalServerMessage = this.errorObject.response.data;
            }
            this.notFound = true;
            break;
          case 500:
            // if the responseData contains '<' it is most likely html, so we dont show it.
            if (this.errorObject.response.data.indexOf("<") == -1) {
              this.internalServerMessage = this.errorObject.response.data;
            }
            this.serverError = true;
            break;
          default:
            this.HandleDefaultError();
            break;
        }
      } else {
        this.HandleDefaultError();
      }
    },
    HandleStatus400() {
      if (
        this.errorObject.response.data &&
        this.errorObject.response.data.errors
      ) {
        for (var property in this.errorObject.response.data.errors) {
          if (this.errorObject.response.data.errors.hasOwnProperty(property)) {
            this.propertyErrors.push({
              propertyName: property.toString(),
              propErrors: this.errorObject.response.data.errors[property],
            });
          }
        }
      } else if (
        this.errorObject.response.data &&
        this.errorObject.response.data[""]
      ) {
        this.otherErrors = this.errorObject.response.data[""];
      } else if (this.errorObject.response.data) {
        this.otherErrors = [this.errorObject.response.data];
      }
    },
    HandleDefaultError() {
      if (this.errorObject.message == "Network Error") {
        this.networkError = true;
      } else {
        this.unknownError = true;
        this.unknownErrorMessage = this.errorObject.message;
      }
    },
  },
};
</script>

<style scoped>
.pre-formatted {
  white-space: pre-wrap;
}
</style>
